import {useEffect, useState} from 'react';
import {setClientData} from '../../../redux/slices/selectedClientSlice';
import {useDispatch} from 'react-redux';
import {
  setProjectNlpSearch,
  storeProjectNWorkSpaceId,
} from '../../../redux/slices/reportsSlice';
import {useLocation, useNavigate} from 'react-router-dom';
import usePermissionsByProjectId from '../../../hooks/permissions/usePermissionsByProjectId';
import {AuthPageLayout} from './shared';
import {Box, Typography} from '@mui/material';
import {EciHomePageTabs, INTENT} from '../../../constants/constants';
import {
  getClientById,
  getPermissionsbyProjectId,
  getProjectByProjectId,
} from '../../../api/ClientManagementService';
import {getDefaultData} from '../../../api/EcaManagementService';
import {t} from 'i18next';

const DeepLinkingScreen = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [isError, setIsError] = useState(false);
  const queryParams = new URLSearchParams(location.search);
  const encodedData = queryParams.get('redirect_data');
  const redirectData = encodedData ? JSON.parse(atob(encodedData)) : null;
  const {setPermissions} = usePermissionsByProjectId(redirectData?.projectId);

  useEffect(() => {
    if (redirectData && redirectData.intent === INTENT.LAUNCH_ECI) {
      loadEciDefaultData();
      loadInitialData();
    }
  }, []);

  const loadInitialData = async () => {
    const controller = new AbortController();
    const signal = controller.signal;

    try {
      const [
        clientDetailsResponse,
        projectDetailsResponse,
        permissionResponse,
      ] = await Promise.all([
        getClientById(redirectData.clientId, signal),
        getProjectByProjectId(redirectData.projectId, signal),
        getPermissionsbyProjectId(
          redirectData.clientId,
          redirectData.projectId
        ),
      ]);
      if (
        clientDetailsResponse &&
        projectDetailsResponse &&
        permissionResponse
      ) {
        const clientDetails = clientDetailsResponse.data.data;
        const projectDetails = projectDetailsResponse.data.data;
        dispatch(
          setClientData({
            clientId: clientDetails.clientId,
            consilioClientId: clientDetails.consilioClientId,
            name: clientDetails.name,
            clientBranch: [],
            bulkUploadClientId: '',
            organizationId: '',
            permissionGroup: [],
            status: '',
            totalActiveBranches: 0,
            totalActiveProjects: 0,
            totalActiveWorkspaces: 0,
            totalBranches: 0,
            totalProjects: 0,
            totalWorkspaces: 0,
            type: '',
          })
        );
        dispatch(
          storeProjectNWorkSpaceId({
            projectId: projectDetails.projectId,
            workspaceId: '',
            projectName: projectDetails.projectName,
            workspaceName: '',
            projectCode: projectDetails.projectCode,
            projectAlphaCode: projectDetails.projectAlphaCode,
          })
        );
        dispatch(setProjectNlpSearch(projectDetails.nplSearchEnabled));
        setPermissions(permissionResponse, redirectData.projectIds);
        localStorage.setItem(
          'currentLink',
          `/eci-home-page?tab=${EciHomePageTabs.ECI_OVERVIEW}`
        );
        navigate(`/eci-home-page?tab=${EciHomePageTabs.ECI_OVERVIEW}`);
      } else {
        setIsError(true);
      }
    } catch {
      controller.abort();
      setIsError(true);
    }
  };

  const loadEciDefaultData = async () => {
    const paramString = `?clientId=${redirectData.clientId}&projectId=${redirectData.projectId}`;
    try {
      await getDefaultData(paramString);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <AuthPageLayout>
      <Box className="login-form">
        <div className="login-content">
          {isError ? (
            <Typography className="typo-text headline2_size mist-color">
              {t('common.somethingWrong')}
            </Typography>
          ) : (
            <Typography className="typo-text headline2_size mist-color">
              {t('auth.login.callbackMsg1')}
              <br />
              {t('auth.login.launchEci')}
            </Typography>
          )}
        </div>
      </Box>
    </AuthPageLayout>
  );
};

export default DeepLinkingScreen;
